import { createContext, useContext } from 'react';

export const CardTemplateContext = createContext();

export const useCardTemplateContext = () => useContext(CardTemplateContext);
